import { StyledTechUL, EmptyListMsg } from "./styled";
import Technology from "../Technology";

//CONTEXT
import { useContext } from "react";
import { TechContext } from "../../context/TechContext";
import { useEffect } from "react";

const TechList = ()=>{

    const { techs } = useContext(TechContext);

    if(techs.length === 0){
        return <EmptyListMsg>Você não tem nenhuma tecnologia cadastrada</EmptyListMsg>
    }
    return(
        <StyledTechUL>
            {
                techs.map((el, index)=>{
                    return <Technology key={index} tech={el}/>
                })
            }
        </StyledTechUL>
    )

}

export default TechList